import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

const animationFeaturedLink = (container) => {
  let links = container.querySelectorAll('.featured-link');

  if (links) {
    for (let i = 0; i < links.length; i++) {
      const title = links[i].querySelector('h4');
      const split = new SplitText(title, { type: 'chars' });
      let length = '+50%';

      if (i === 0) {
        length = '-50%';
      }

      gsap
        .timeline({
          scrollTrigger: {
            trigger: links[i].parentNode,
            start: 'top+=100px bottom',
            //markers: true,
            once: true,
          },
        })
        .from(links[i], {
          duration: 1,
          x: length,
          scale: 1.1,
          autoAlpha: 0,
          ease: 'power1.out',
        })
        .from(split.chars, {
          duration: 0.3,
          stagger: 0.025,
          y: 20,
          autoAlpha: 0,
        });
    }
  }
};

export default animationFeaturedLink;
